import { isValidHexColor } from '@utils/utilities'
import { useEffect, useState } from 'react'
import { HiPlus } from 'react-icons/hi'
import { UnifiedColorPicker } from '@pageFeatures/design/unifiedColorPicker/unifiedColorPicker'
import { IUnifiedPickerTabConfig } from '@pageFeatures/design/unifiedColorPicker/unifiedColorPicker.types'

export function BriefAddColorBtn({
  onSelection,
  pickerTemplate,
}: {
  onSelection: (color) => void
  pickerTemplate: IUnifiedPickerTabConfig[]
}) {
  const [pickerIsOpen, setPickerIsOpen] = useState<boolean>(false)
  const [selectedColor, setSelectedColor] = useState<string>('')

  useEffect(() => {
    if (!pickerIsOpen) {
      onSelection(selectedColor)
      setSelectedColor('')
    }
  }, [pickerIsOpen, selectedColor])

  return (
    <div className="relative w-full xs:w-[calc(50%-5px)] font-mori">
      <button
        className="flex items-center justify-between h-[56px] px-6 py-4 border-2 bg-core-white border-black-10 rounded-[6px] cursor-pointer w-full"
        onClick={() => {
          setPickerIsOpen(!pickerIsOpen)
        }}
      >
        <div className="flex items-center">
          {isValidHexColor(selectedColor) && (
            <div
              className="w-[24px] h-[24px] rounded-full mr-3 border-2 border-black-20"
              style={{
                backgroundColor: selectedColor,
              }}
            />
          )}
          <div className="flex flex-col items-start cursor-pointer">
            <span className="text-[14px] leading-none text-acai mb-2">
              Add Color
            </span>
            <span className="text-[11px] leading-none text-acai-40 uppercase">
              {selectedColor}
            </span>
          </div>
        </div>
        <HiPlus className="text-2xl font-light transition-all text-black-20" />
      </button>

      {pickerIsOpen && (
        <div
          className="w-full max-w-[320px] absolute top-[calc(100%+8px)] -left-1 rounded-[16px] bg-core-white border-2 border-black-10 shadow-lg z-1"
          onClick={(e) => e.stopPropagation()}
          onMouseLeave={() => setPickerIsOpen(false)}
        >
          <UnifiedColorPicker
            tabs={pickerTemplate}
            onSelected={(color) => {
              if (color?.value) {
                setSelectedColor(color.value)
              }
            }}
            onClose={() => setPickerIsOpen(false)}
          />
        </div>
      )}
    </div>
  )
}
